module.exports = __webpack_public_path__ + "static/media/YearInReview2020.fd7fe07a.png";